export default __webpack_public_path__ + "static/media/copy.07377e65.svg";